"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectManagementClientsComponent = void 0;
const core_1 = require("@angular/core");
const connect_organization_1 = require("./connect-organization");
const _ = require("lodash");
const connect_client_1 = require("./connect-client");
const angular2_modal_1 = require("angular2-modal");
const connect_management_save_client_modal_component_1 = require("./connect-management-save-client-modal.component");
const notification_service_1 = require("./notification.service");
let ConnectManagementClientsComponent = class ConnectManagementClientsComponent {
    constructor(_modal, _talk) {
        this._modal = _modal;
        this._talk = _talk;
        this.onSaved = new core_1.EventEmitter();
    }
    isEmpty() {
        return !_.get(this.organization, "clients.length");
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let client = new connect_client_1.ConnectClient({
                    organization: this.organization.id,
                });
                let modal = yield this._modal.open(connect_management_save_client_modal_component_1.ConnectManagementSaveClientModalComponent, (0, angular2_modal_1.overlayConfigFactory)({ client: client }));
                let result = yield modal.result;
                if (_.get(result, "saved")) {
                    this.onSaved.emit();
                }
            }
            catch (err) {
                this._talk.broadcast("Failed to Create Client");
            }
        });
    }
    sync(client) {
        return __awaiter(this, void 0, void 0, function* () {
            let message = `Are you sure you want to sync RTBX ID: ${client.rtbxId} - (${client.name})?`;
            if (!confirm(message)) {
                return null;
            }
            try {
                yield client.sync();
            }
            catch (err) {
                this._talk.broadcast("Failed to Sync Client");
            }
            return client;
        });
    }
    delete(client) {
        return __awaiter(this, void 0, void 0, function* () {
            let message = `Are you sure you want to delete RTBX ID: ${client.rtbxId} - (${client.name})?`;
            if (this.organization.clients.length === 1) {
                message += `\n***NOTE*** this is the last remaining client on this organization.`;
            }
            if (!confirm(message)) {
                return null;
            }
            try {
                yield client.destroy();
                this.onSaved.emit();
            }
            catch (err) {
                this._talk.broadcast("Failed to Delete Client");
            }
            return client;
        });
    }
    createDisabled() {
        return !this.organization;
    }
};
exports.ConnectManagementClientsComponent = ConnectManagementClientsComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", connect_organization_1.ConnectOrganization)
], ConnectManagementClientsComponent.prototype, "organization", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], ConnectManagementClientsComponent.prototype, "onSaved", void 0);
exports.ConnectManagementClientsComponent = ConnectManagementClientsComponent = __decorate([
    (0, core_1.Component)({
        selector: "connect-management-clients",
        templateUrl: "app/connect-management-clients.component.html",
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [angular2_modal_1.Modal, notification_service_1.NotificationService])
], ConnectManagementClientsComponent);
//# sourceMappingURL=connect-management-clients.component.js.map